export class OddType {
  id: number | null = null;
  guid: string | null = null;
  name: string | null = null;
  sport: any = [];
}
